import { Home, BarChart2, Plus, Clock, Fuel } from 'lucide-react'

const LEFT_TABS = [
  { id: 'home', label: 'Home', Icon: Home },
  { id: 'analytics', label: 'Analytics', Icon: BarChart2 },
]

const RIGHT_TABS = [
  { id: 'credit', label: 'Credit', Icon: Fuel },
  { id: 'history', label: 'History', Icon: Clock },
]

function TabButton({ id, label, Icon, activeTab, onTabChange }) {
  const isActive = activeTab === id
  return (
    <button
      onClick={() => onTabChange(id)}
      className={`flex-1 flex flex-col items-center justify-center py-2 min-h-[56px] transition-colors relative ${
        isActive ? 'text-blue-600' : 'text-gray-400'
      }`}
    >
      {isActive && (
        <span className="absolute top-0 left-4 right-4 h-0.5 bg-blue-600 rounded-full" />
      )}
      <Icon className="w-5 h-5 mb-1" strokeWidth={isActive ? 2.5 : 1.5} />
      <span className="text-xs font-medium">{label}</span>
    </button>
  )
}

export default function BottomNav({ activeTab, onTabChange, canAdd, onAddPress }) {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="flex items-end max-w-7xl mx-auto">
        {LEFT_TABS.map(({ id, label, Icon }) => (
          <TabButton key={id} id={id} label={label} Icon={Icon} activeTab={activeTab} onTabChange={onTabChange} />
        ))}

        {/* Floating center + button */}
        <div className="flex-1 flex flex-col items-center pb-2">
          <button
            onClick={canAdd ? onAddPress : undefined}
            disabled={!canAdd}
            className={`w-14 h-14 rounded-full flex items-center justify-center -translate-y-4 transition-all active:scale-95 shadow-lg ${
              canAdd
                ? 'bg-blue-600 shadow-blue-200 hover:bg-blue-700'
                : 'bg-gray-300 shadow-gray-100 cursor-not-allowed'
            }`}
          >
            <Plus className="w-7 h-7 text-white" strokeWidth={2.5} />
          </button>
        </div>

        {RIGHT_TABS.map(({ id, label, Icon }) => (
          <TabButton key={id} id={id} label={label} Icon={Icon} activeTab={activeTab} onTabChange={onTabChange} />
        ))}
      </div>
    </div>
  )
}
